import { render, staticRenderFns } from "./NoNotificationsStub.vue?vue&type=template&id=6b98f0cf&lang=pug&"
import script from "./NoNotificationsStub.vue?vue&type=script&lang=ts&"
export * from "./NoNotificationsStub.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports